import { App } from '@capacitor/app';
import { Toast } from '@capacitor/toast';
import { IonAlert, IonContent, IonFab, IonFabButton, IonIcon, IonImg, IonLabel, IonLoading, IonModal, IonPage, isPlatform, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react';
import { locateSharp } from 'ionicons/icons';
import * as Leaflet from 'leaflet';
import React, { useContext, useState } from 'react';
import Iframe from "react-iframe";
import { useHistory, useLocation } from 'react-router-dom';
import { listaEmpresa, listaOperacaoPorStatus, requestService, usuarioAtualizarLocalizacao } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import Notificacoes from '../Notificacoes/Notificacoes';
import './Roteiro.css';
import maps from './imgs/maps.png';
import waze from './imgs/waze.png';

const Roteiro: React.FC = () => {

  const history = useHistory();
  const location = useLocation<any>();
  const [position, setPosition] = React.useState({ lat: Number(localStorage.getItem("latitude") || "-23.550404108596"), lng: Number(localStorage.getItem("longitude") || "-46.633911201448136") });

  const [textToast, setTextToast] = useState("");

  const [showErro, setShowErro] = useState(false);
  const [showLoading2, setShowLoading2] = useState(false);
  const [mapaGoogle, setMapaGoogle] = useState(window.localStorage.getItem("mapaGoogle") === "true");
  const [leafletMap, setLeafletMap] = useState<any>(null);
  const [pageLoading, setPageLoading] = useState<boolean>(true);
  const [showErroGPS, setShowErroGPS] = useState<boolean>(false);
  const [chamadaRealizada1, setChamadaRealizada1] = useState(false);
  const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  let mapa: any = null;
  let mark: any = null;
  let setView: boolean = true;

  const myIconXeguei = Leaflet.icon({
    iconUrl: '/assets/icon1.svg',
    iconSize: [50, 50],
    popupAnchor: [0, -20]
  });

  const myIcon = Leaflet.icon({
    iconUrl: '/assets/Logo.svg',
    iconSize: [30, 30],
    popupAnchor: [0, -20]
  });

  useIonViewDidEnter(() => {
    if (isPlatform('ios')) {
      App.addListener('appStateChange', ({ isActive }) => {
        // console.log('App state changed. Is active?', isActive);
        if (isActive) {
          console.log('console log reativado');// Do fun stuff.
          if (history.location.pathname.match("/cliente/roteiro")) {
            setPageLoading(false);
            history.go(0);
          }
        }
      });
    }
    listaEmpresasPorMarca();
    setEsconderMenu(false);
  });


  if (location && location != undefined && location.state && location.state != undefined && location.state.recarregar != undefined && location.state.recarregar) {
    if (!chamadaRealizada1) {
      setChamadaRealizada1(true);
      history.replace("/cliente/roteiro");
    }
  }



  useIonViewDidLeave(() => {
    cleanPreviousMap();
  });

  function cleanPreviousMap() {

    if (mapa != null && mapa != undefined) {
      console.log("map stoped")
      mapa?.stopLocate();
      mapa?.remove();
      // circle?.remove();
      mark?.remove();
      mapa = undefined;
      // circle = undefined;
      mark = undefined;
      setView = true;
    }
  }

  function loadMap() {
    console.log("startMap");
    try {
      console.log('limpou 2');
      // link para os possiveis tratamentos de erro: https://stackoverflow.com/questions/19186428/refresh-leaflet-map-map-container-is-already-initialized
      cleanPreviousMap();

      mapa = Leaflet.map('mapId').fitWorld();
      setLeafletMap(mapa);

      Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '© OpenStreetMap',
      }).addTo(mapa);


      mapa.zoomControl.remove();
      Leaflet.control.zoom({ position: 'bottomleft' }).addTo(mapa);

      mapa.on('locationfound', onLocationFound);

      mapa.on('locationerror', onLocationError);

      mapa.locate({ watch: true, setView: false, enableHighAccuracy: true });





      requestService(listaEmpresa.url, {
        method: listaEmpresa.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log("response", response);

          if (response) {

            try {


              response.map((value: any, index: any, array: any) => (


                Leaflet.marker([value.empresaLatitude, value.empresaLongitude], { icon: myIconXeguei, draggable: false }).addTo(mapa)

                  .bindPopup('<b>' + value.empresaNome + '</b><br>'
                    + "<a target='_blank' href='" + value.empresaUrl + "'>Detalhes da empresa</a></b><br><br>"
                    + "<a target='_blank' href='https://www.google.com/maps/search/?api=1&query=" + (value ? value.empresaLatitude.concat(",").concat(value.empresaLongitude) : "") + "'><img src=" + maps + " alt='maps' /></a>&nbsp&nbsp&nbsp"
                    + "<a target='_blank' href='https://waze.com/ul?ll=" + (value ? value.empresaLatitude.concat("%2C").concat(value.empresaLongitude) + "&navigate=yes" : "") + "'><img src=" + waze + " alt='waze' /></a><br>"
                    + montarCampanha(value.campanha), { closeButton: false, minWidth: 200, maxWidth: 200 })
              ));

            } catch (error) {
              console.log("error", error);
            }

          }

        },
        (error: any) => {
          if (error.status === 426) { // atualizar versao
            history.replace("/atualizar");
          }
          else if (error.status !== 408) {
            history.replace("/primeiroacesso/");
          }
        });

    }
    catch (e: any) {
      console.log("deu erro" + e.message);
      window.location.reload();
    }
  }

  function montarCampanha(lista: any) {

    let texto: string = "";
    lista.map((value: any, index: any, array: any) => (
      texto = texto + "<br>" + value
    ));

    return texto;
  }


  function onLocationFound(e: any) {
    console.log("localizacao encontrada:", e.latlng)
    // Raio de localização dos locais para realizar operação
    var radius = 100;//e.accuracy;    
    if (mark && mark != null && mark != undefined) {
      mark.setLatLng(e.latlng);
      mark.setPopupContent(
        "Navegue pelo mapa para obter mais informações."
        , { closeButton: false, minWidth: 200, maxWidth: 200 });
    }
    else {
      console.log("mark", mark);


      mark = Leaflet.marker(e.latlng, { icon: myIcon, draggable: true }).addTo(mapa).bindPopup(
        "Navegue pelo mapa para obter mais informações."

        , { closeButton: false, minWidth: 200, maxWidth: 200 }).openPopup();
      setTimeout(() => {
        if (mark && mark != null && mark != undefined) {
          mark.closePopup();
        }
      }, 20000);




    }

    if (setView) {
      mapa.setView(e.latlng, 11);
      setPageLoading(false);
      setView = false;
    }

    // Guarda as variaveis para abertura de operacao
    setPosition(e.latlng);
    window.localStorage.setItem("latitude", e.latlng.lat.toString());
    window.localStorage.setItem("longitude", e.latlng.lng.toString());

    //console.log("deu watch");
    let latitudeArmazenada = Number(window.localStorage.getItem("latitude"));
    let longitudeArmazenada = Number(window.localStorage.getItem("longitude"));

    let latitudeAndouArmazenada = Number(window.localStorage.getItem("latitudeAndou"));
    let longitudeAndouArmazenada = Number(window.localStorage.getItem("longitudeAndou"));

    console.log(position.lat);
    console.log(latitudeArmazenada);
    console.log(Math.abs(Math.abs(latitudeAndouArmazenada) - Math.abs(latitudeArmazenada)));
    if (Math.abs(Math.abs(latitudeAndouArmazenada) - Math.abs(latitudeArmazenada)) >= 0.001 || //0.0005
      Math.abs(Math.abs(longitudeAndouArmazenada) - Math.abs(longitudeArmazenada)) >= 0.001) {
      console.log('atualizalocalizacao');
      atualizarLocalicacaoDynamo();

      window.localStorage.setItem("latitudeAndou", e.latlng.lat.toString());
      window.localStorage.setItem("longitudeAndou", e.latlng.lng.toString());
    }

  }


  const atualizarLocalicacaoDynamo = async () => {
    requestService(usuarioAtualizarLocalizacao.url, {
      method: usuarioAtualizarLocalizacao.method,
      headers: [
        ["token", window.localStorage.getItem("token")],
        ["perfil", window.localStorage.getItem("perfil")],
        ["marca", window.localStorage.getItem("marca") || ""],
      ],
      body: JSON.stringify({
        "latitude": window.localStorage.getItem("latitude") || '',
        "longitude": window.localStorage.getItem("longitude") || ''
      }),
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log('atualizou localização no Dynamo');
      },
      (error: any) => {
        //todo: verificar para tratar caso ocorra erro
        console.log(error);
      });
  }


  function onLocationError(e: any) {
    console.log("Erro de localizacao. Ative o GPS." + e.message);
    setPageLoading(false);
    if (e.code != 3) {
      //setShowErroGPS(true);
    }
  }

  function centerMapLocation() {
    console.log("centerlocaiton", leafletMap, position);
    if (leafletMap != null || leafletMap != undefined) {
      leafletMap.setView(position, leafletMap.getZoom());
    }
    else {
      loadMap();
    }
  }

  function atualizaMapaGeolocationLeaflet() {
    centerMapLocation();
  }

  function atualizaMapaGeolocation() {
    navigator.geolocation.getCurrentPosition(
      (result) => {
        console.log('pegou geolocation');
        // if (Math.abs(Math.abs(result.coords.latitude) - Math.abs(window.latitude)) >= 0.0005 ||
        //   Math.abs(Math.abs(result.coords.longitude) - Math.abs(window.longitude)) >= 0.0005) {
        setPosition({
          lat: result.coords.latitude,
          lng: result.coords.longitude
        });

        window.localStorage.setItem("latitude", result.coords.latitude.toString());
        window.localStorage.setItem("longitude", result.coords.longitude.toString());

        // window.latitude = result.coords.latitude;
        // window.longitude = result.coords.longitude;
        //}
      },
      (rejected) => {
        console.log("reject getCurrentPosition", rejected);
      },
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 1000
      }
    );
  }

  function listaEmpresasPorMarca() {
    let myPromise = new Promise((myResolve, myReject) => {
      fetch(
        listaOperacaoPorStatus.url.replace("{status}", "Ativo"),
        {
          method: listaOperacaoPorStatus.method,
          headers: [
            ["token", window.localStorage.getItem("token") || ""],
            ["versao", window.localStorage.getItem("versao") || ""],
            ["perfil", window.localStorage.getItem("perfil") || ""],
            ["marca", window.localStorage.getItem("marca") || ""],
          ],
          credentials: 'include'
        }).then(res => {
          if (res.status === 426) {
            myReject(426);
            //history.replace("/atualizar");
          }
          else if (res.status === 401) {
            myReject(401);
            //history.replace("/primeiroacesso");
          }
          else if (res.status === 200 || res.status === 201) {
            res.json().then(response => {
              console.log(response);
              myResolve(response);
            }).catch(() => myReject(401));
          }
          else {
            myReject(401);
          };
        });
    }
    );

    myPromise.then(
      (value: any) => {
        loadMap();
      },
      (erro) => {
        Toast.show(
          {
            text: 'Erro: ' + erro,
            duration: "long"
          }
        );
      }
    )

  }

  async function closeModalNotificacoes() {
    setShowNotificacoes(false);
  }

  async function closeModalSimpleNotificacoes() {
    setShowNotificacoes(false);
  }

  return (
    <IonPage>


      <IonContent className={"Roteiro"} >

        {/* <IonFab vertical="bottom" horizontal="end" slot="fixed" edge style={{ "bottom": "20px" }} hidden={window.localStorage.getItem("empresaTelefone") ? false : true}>

          <IonFabButton color="tertiary">
            <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (window.localStorage.getItem("empresaTelefone") || "")}>
              <IonIcon color="light" size="large" icon={chatbubbles} />
            </a>
          </IonFabButton>
        </IonFab> */}

        <div id="framemaps" style={{ pointerEvents: "none", position: "fixed", top: 0, left: 0, width: "100%", height: "105%", display: (mapaGoogle ? "block" : "none") }}>
          <Iframe key={"0"}
            url={"https://www.google.com/maps/embed/v1/view?key=AIzaSyDsbVscwNhxsgMynsga97Rea933LJLG5Jw&center=" + position.lat + "," + position.lng + "&zoom=15&maptype=roadmap"}
            width="100%"
            height="100%"
            id="myId"
            className="myClassname"
            display="inline"
            position="absolute"
            frameBorder={0}
            styles={{ border: "0" }}
          />
        </div>
        <div id="carrinho" style={{ position: "relative", width: "100%", height: "105%", display: (mapaGoogle ? "flex" : "none") }}>
          <img width={60} height={60} style={{ margin: "auto" }} src={"/assets/Logo.svg"}></img>
        </div>

        <IonFab vertical="bottom" horizontal="end" slot="fixed" edge style={{ "bottom": "20px" }} >
          <IonFabButton color="tertiary" onClick={() => { !mapaGoogle ? atualizaMapaGeolocationLeaflet() : atualizaMapaGeolocation(); }} >
            <IonIcon color="light" icon={locateSharp}></IonIcon>
          </IonFabButton>
        </IonFab>

        <div className={"mapId"} style={{ position: "relative", width: "100%", height: "100%", display: (mapaGoogle ? "none" : "block") }}>
          <IonImg src="Logo.png" hidden={true}></IonImg>
          <div id="mapId" style={{ width: "100%", height: "100%" }}></div>
          <IonLabel className={"labellatlng"} style={{ bottom: 20, position: "relative", fontSize: "10px" }}>{position.lat.toString().substr(0, 9) + ", " + position.lng.toString().substr(0, 9)}</IonLabel>
        </div>

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading2}
          onDidDismiss={() => { setShowLoading2(false); }}
          spinner='circles'
        />
        <IonLoading
          cssClass='my-custom-class'
          isOpen={pageLoading}
          onDidDismiss={() => { setPageLoading(false); }}
          spinner='circles'
        />
        <IonAlert
          isOpen={showErroGPS}
          onDidDismiss={() => { setShowErroGPS(false); }}
          backdropDismiss={false}
          cssClass='my-custom-class'
          header={'Ative o GPS'}
          message={'Não conseguimos encontrar sua localização. <strong>Ative seu GPS</strong> e clique em tentar novamente!'}
          buttons={[
            {
              text: 'Tentar novamente!',
              handler: () => {
                //history.push('/cliente/roteiro');
                window.location.reload();
              }
            }
          ]}
        />

      </IonContent>

      <IonAlert isOpen={showErro}
        onDidDismiss={() => setShowErro(false)}
        header={'Ops...'}
        message={textToast}
        buttons={['OK']}
      />

      <div className="content">
        <IonModal isOpen={showNotificacoes} onDidDismiss={() => { setShowNotificacoes(false); }}>
          <Notificacoes closeAction={closeModalNotificacoes} closeActionSimple={closeModalSimpleNotificacoes}></Notificacoes>
        </IonModal>

      </div>


    </IonPage>
  );
};

export default Roteiro;